import usePdtEntities from 'common/fetchHooks/pmProvider/usePdtEntities';
import LabelsList from 'components/LabelsList';
import { Flex } from 'components/base/layout-components';
import { useMemo } from 'react';
import LabelListTooltipLoader from './LabelListTooltipLoader';
import { groupBy } from 'lodash';

const SUPPORTED_FILTERS = [
  { label: 'boards', entityKey: 'boards', entityNameKey: 'name' },
  { label: 'labels', entityKey: 'labels', entityNameKey: null },
  { label: 'epics', entityKey: 'epics', entityNameKey: null },
  { label: 'fix versions', entityKey: 'fix_versions', entityNameKey: null }
];

const PdtTooltip = ({ id, name }) => {
  const { isLoading, getEntityById } = usePdtEntities();
  const entity = getEntityById(id);

  const pdtProjectFilters = entity?.filters || {};

  const pdtFiltersList = useMemo(() => {
    const filtersLabels = SUPPORTED_FILTERS.map(filter => ({
      key: filter.label,
      label: filter.label,
      values: (pdtProjectFilters[filter.entityKey] || []).map(item => ({
        title: filter.entityNameKey ? item[filter.entityNameKey] : item
      }))
    }));
    const fieldsLabels = (pdtProjectFilters.fields || []).map(field => ({
      key: field?.name,
      label: field?.name,
      values: (field?.values || []).map(value => ({
        title: value
      }))
    }));

    const parentIssueByType = groupBy(pdtProjectFilters?.parent_issues, 'type');
    const parentIssuesLabels = Object.keys(parentIssueByType).map(issueType => {
      const issues = parentIssueByType?.[issueType] || [];
      return {
        key: issueType,
        label: issueType,
        values: issues.map(issue => ({
          title: issue.title
        }))
      };
    });

    return [...filtersLabels, ...parentIssuesLabels, ...fieldsLabels];
  }, [entity]);

  return (
    <Flex padding='small' direction='column'>
      <Flex>
        <b>{name}</b>
        &nbsp; is composed of:
      </Flex>
      <br />
      {isLoading ? (
        <LabelListTooltipLoader />
      ) : (
        <LabelsList list={pdtFiltersList} />
      )}
    </Flex>
  );
};

export default PdtTooltip;
